/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { Drawer, Grid, Button } from '@mui/material'
import { connect } from 'react-redux'
import IntlMessages from '../../../../util/IntlMessages'
import NavigatorList from './navigator_list'
import useStyles from './style'
import Content from './content'

function Navigation(props) {
    const classes = useStyles()
    const anchor = 'bottom'

    return (
        <React.Fragment>
            <Drawer
                anchor={anchor}
                open={props.navigation}
                onClose={() => props.setNavigation(false)}
            >
                <Grid className={classes.root}>
                    <Content />
                    <NavigatorList {...props}/>
                    <Button onClick={() => props.setNavigation(false)} fullWidth variant='contained' color='secondary'>
                        <IntlMessages id="iGaveUp" />
                    </Button>
                </Grid>
            </Drawer>
        </React.Fragment >
    )
}

const mapStateToProps = (state) => {
    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Navigation)